import {CommandeFormationStore} from "@common/store/commande-formation.store";
import {DocumentComplementaireDto, FormationDto} from "@resources/resources";
import {ActivatedRoute, Router} from "@angular/router";
import {AsiFileService, AsiTable, AsiTableData, AsiTableSelectionModel} from "@asi-ngtools/lib";
import {Component, ViewChild} from "@angular/core";
import * as lodash from "lodash";
import {ArianeElement, ArianeStore, MomentService, UserStore} from "@digicerba/common";


@Component({
  selector: 'catalogue-formation-component',
  templateUrl: './catalogue-formation.component.html',
  host: {'class': 'page'}
})
export class CatalogueFormationComponent {

  @ViewChild('cmFormationDataTable') formationTable: AsiTable<FormationDto>;
  asiTableData: AsiTableData<FormationDto> = new AsiTableData<FormationDto>();
  selectionModel = new AsiTableSelectionModel("id", false);
  count: number;
  list: Array<Object>
  selectedAll: boolean
  provisoire: any
  event: any
  documentsComplementaires: DocumentComplementaireDto[];
  isAdmin: boolean
  errorSelection: boolean;


  constructor(private momentService: MomentService, private arianeStore: ArianeStore, private userStore: UserStore, private router: Router,
              private activatedRoute: ActivatedRoute, private fileUtils: AsiFileService, private commandeFormationStore: CommandeFormationStore) {

    this.isAdmin = userStore.isAdmin();

    let arianeElements: Array<ArianeElement>;
    arianeElements = [
      {
        libelle: "Catalogue de formation",
        route: "/liste-formations"
      },
    ];
    arianeStore.updateElements(arianeElements);
  }

  ngOnInit() {
    this.errorSelection = false;
    this.asiTableData.results = this.activatedRoute.snapshot.data['formations'];
    this.documentsComplementaires = this.activatedRoute.snapshot.data['documentsComplementaires'];
    this.count = this.asiTableData.results.length
    this.asiTableData.results.filter(resultat => resultat.dateFormation = this.momentService.formatDate(resultat.dateFormation));
  }

  ngAfterContentInit() {
    this.formationTable.updateData(this.asiTableData);
  }


  soloRegister(id: number) {
    this.commandeFormationStore.addFormations(this.asiTableData.results.filter(item => item.id === id));
    this.router.navigate(['cerba/inscription']);
  }

  register() {
    if (this.selectionModel.nbItemsSelected > 0) {
      this.commandeFormationStore.addFormations(this.getFormationsSelectionne());
      this.router.navigate(['cerba/inscription']);
    } else {
      this.errorSelection = true;
    }
  }

  private getFormationsSelectionne(): Array<FormationDto> {
    let formations = new Array<FormationDto>();
    if (this.selectionModel.allChecked == false) {
      this.selectionModel.itemsIncluded.forEach(formation => {
        formations.push(formation);
      });
    } else {
      this.asiTableData.results.forEach(formation => {
        if (lodash.indexOf(this.selectionModel.itemsExcluded, formation) == -1) {
          formations.push(formation);
        }
      });
    }
    return formations;
  }

  downloadFile(document: DocumentComplementaireDto) {
    window.open(document.url, '_blank');
  }

  public isSelectable(row: FormationDto) {
    let result: boolean = true;
    let dateParts = row.dateFormation.split("/");
    let dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]); // month is 0-based
    let now = new Date();

    if (row.active == false || row.nombrePlacesReservees >= row.nombrePlaces || dateObject.getTime() < now.getTime()) {
      result = false;
    }
    return {'activeCheckbox': !result};
  }

  isActive(row: FormationDto): boolean {
    if (row.active === true) {
      return true;
    } else {
      return false;
    }
  }

  isPassed(row: FormationDto): boolean {
    let df = this.momentService.parse(row.dateFormation, 'DD/MM/YYYY');
    let now = this.momentService.parse(this.momentService.formatToLocalDate(new Date()), 'YYYY-MM-DD');
    if (df < now) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-formation/digicerba-catalogue-formation-web/src/angular/cerba/src/app/pages/cerba/pages/commande/catalogue-formation.component.ts